import Component from '../../js/component';

class Tag extends Component {
  constructor(props) {
    super();

    this.options = {
      parent: document,
    };

    Object.assign(this.options, props);

    this.init();
  }

  init() {
    this.events();
  }

  events() {
    $(this.options.parent).on('click.cd.tag.close', `${this.options.el} i`, (event) => this.closeEvent(event));
  }

  closeEvent(event) {
    let $this = $(event.currentTarget);
    let $parent = $this.parent();
    $parent.addClass('cd-hide');
    
    setTimeout(() => {
      $parent.remove();
    }, 300);

    this.emit('close', $parent);
  }
}

export default Tag;



//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/tag/tag.js
// module id = 574
// module chunks = 9